import { VerificationCodeForm } from '@core/Areas/Settings/Components/MFASettings'
import {
  MfaCodePageHeader,
  MfaCodePageText,
} from '@core/Areas/Settings/Components/MFASettings/Pages/VerificationCodePage.styles'
import { MainContainer } from '@core/Components/Containers'
import styled from '@emotion/styled'
import { colors, font, radius, spacing } from '@mobi/component-library/Theme/Common'
import { hexColors } from '@mobi/settings/hexColors'
import React, { useEffect, useState } from 'react'
import { useLoginState } from '../../hooks'
import { mfaCodeText } from '@core/Areas/Settings/Components/MFASettings/helpers'

export const LoginVerificationCodePage = ({
  state,
  handlers,
}: ReturnType<typeof useLoginState>) => {
  const [lastKnownHint, setLastKnownHint] = useState(state.mfaHint)
  const [lastKnownFactor, setLastKnownFactor] = useState(state.mfaFactor)

  useEffect(() => {
    if (state.mfaHint) setLastKnownHint(state.mfaHint)
    if (state.mfaFactor) setLastKnownFactor(state.mfaFactor)
  }, [state.mfaHint, state.mfaFactor])

  const displayHint = state.mfaHint || lastKnownHint
  const displayFactor = state.mfaFactor || lastKnownFactor

  const onErrorReset = () => {
    handlers.setErrorMessage(undefined)
  }

  return (
    <MainContainer data-tid-mfa-verification-page background='white'>
      <MfaPageContainer>
        <MfaCodePageHeader>Verify your identity</MfaCodePageHeader>
        {displayFactor && displayHint ? (
          <MfaCodePageText>{mfaCodeText(displayFactor, displayHint)}</MfaCodePageText>
        ) : null}
        <VerificationCodeForm
          onVerify={handlers.handleMfaChallenge}
          onResend={handlers.handleMfaChallengeResend}
          errorMessage={state.errorMessage}
          onErrorReset={onErrorReset}
        />
      </MfaPageContainer>
      {state.errorMessage ? (
        <HelpText>
          If you need to update your contact details, please call us on <b>1300 36 36 88</b>
        </HelpText>
      ) : null}
    </MainContainer>
  )
}

const MfaPageContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  padding: `${spacing.bigx1} ${spacing.md}`,
  fontFamily: font.family.primary,

  h1: {
    fontFamily: font.family.primary,
    ...font.size.xl4,
    fontWeight: font.weight.semibold,
    alignSelf: 'left',
    padding: 0,
    color: hexColors.black,
    textTransform: 'capitalize',
  },
})

const HelpText = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: `${spacing.bigx1} ${spacing.smx1}`,
  backgroundColor: colors.neutral[100],
  borderRadius: radius.md,
  fontFamily: font.family.primary,
  color: colors.neutral[800],
  ...font.size.sm,
  margin: '-4px 32px',

  p: {
    ...font.size.sm,
    margin: 0,
  },
})
